import { QuickFiltersValueDisplayUses } from '../../types/quickFilters/QuickFiltersValueDisplayUses';
import { useMemo } from 'react';
import RollingDateConfig from 'customer-data-filters-ui/filterQueryFormat/rollingDates/RollingDateConfig';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import QuickFiltersTags from './QuickFiltersTags';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickFiltersRollingDateValueDisplay = props => {
  const {
    condition,
    onValueDelete,
    use
  } = props;
  const i18nToken = useMemo(() => RollingDateConfig.toRollingDateOptionValue(condition.value), [condition.value]);
  const label = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: `customerDataFiltersUI.customerDataFilters.RollingDates.options.text.${i18nToken}`
  });
  if (use === QuickFiltersValueDisplayUses.STRING) {
    return label;
  }
  const tags = [{
    value: i18nToken,
    label
  }];
  return /*#__PURE__*/_jsx(QuickFiltersTags, {
    tags: tags,
    onTagClose: () => onValueDelete()
  });
};
export default QuickFiltersRollingDateValueDisplay;